module.exports = __webpack_public_path__ + "img/mac_pc.76c1e774.webp";